import { useRecordContext, useTranslate } from 'ra-core';
import { ReferenceArrayInput } from '../../components/admin/reference-array-input';
import { CheckboxGroupInput } from '../Moonstar/CheckboxGroupInput';

export const RolePermissionsEditor = () => {
  const translate = useTranslate();
  const systemType = useRecordContext()?.systemType;
  const isAdminRole = systemType === 'admin';

  return (
    <ReferenceArrayInput
      source="permissionIds"
      reference="permissions"
      perPage={1_000}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <CheckboxGroupInput
        optionText={(permission: { name: string; description?: string }) => (
          <span className="flex flex-col gap-0.5 leading-tight">
            <span>{permission.name}</span>
            <span className="text-xs text-muted-foreground">
              {permission.description}
            </span>
          </span>
        )}
        readOnly={isAdminRole}
        helperText={
          isAdminRole
            ? translate('moonstar.roles.adminRoleHelperText')
            : undefined
        }
      />
    </ReferenceArrayInput>
  );
};
